var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClickAnywhere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 50.847 39.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6165",
    "data-name": "Group 6165",
    transform: "translate(0 -53.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6166",
    "data-name": "Group 6166",
    transform: "translate(5.931 56.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6165-2",
    "data-name": "Group 6165",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19354",
    "data-name": "Path 19354",
    d: "M96.761,97.149l-8.7-9.557a4.429,4.429,0,0,0-6.263.014,4.329,4.329,0,0,0-1.12,1.913,4.432,4.432,0,0,0-6.943,2.311,4.434,4.434,0,0,0-5.818.4,4.377,4.377,0,0,0-1.11,1.867l-4.1-4.1a4.428,4.428,0,0,0-6.263,6.261L72.2,112.007l-9.342,1.466a5.181,5.181,0,0,0-4.428,5.1,3.474,3.474,0,0,0,3.47,3.469H83.711a12.642,12.642,0,0,0,9-3.726l3.639-3.638a12.7,12.7,0,0,0,.414-17.534Zm-2.05,15.9-3.639,3.638a10.344,10.344,0,0,1-7.362,3.048H61.9a1.157,1.157,0,0,1-1.157-1.157,2.862,2.862,0,0,1,2.459-2.817l11.6-1.823a1.155,1.155,0,0,0,.639-1.959L58.081,94.625a2.115,2.115,0,0,1,2.991-2.991l11.575,11.572a1.156,1.156,0,1,0,1.633-1.638l-4.727-4.725a2.115,2.115,0,0,1,2.991-2.991l4.729,4.728a1.156,1.156,0,1,0,1.633-1.638L76.5,94.531a2.115,2.115,0,0,1,2.991-2.991l2.425,2.424s0,0,0,0l0,0,0,0,0,0h0a0,0,0,0,1,0,0,1.157,1.157,0,0,0,1.612-1.658l-.1-.1a2.116,2.116,0,0,1,2.952-3.03l8.662,9.518a10.393,10.393,0,0,1-.34,14.343Z",
    transform: "translate(-55.153 -86.302)",
    fill: "#96006b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6168",
    "data-name": "Group 6168",
    transform: "translate(0 53.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6167",
    "data-name": "Group 6167",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19355",
    "data-name": "Path 19355",
    d: "M19.719,59.419A10.313,10.313,0,1,0,6.086,73.055a1.148,1.148,0,0,0,.945-2.092,8.019,8.019,0,1,1,10.6-10.6,1.147,1.147,0,1,0,2.09-.945Z",
    transform: "translate(0 -53.333)",
    fill: "#ff0185"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickAnywhere);
export default __webpack_public_path__ + "static/media/ClickAnywhere.43da110a52b138c2c176b8be4ebc539e.svg";
export { ForwardRef as ReactComponent };